
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBlowerOffVertical as ObiBlowerOffVerticalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-blower-off-vertical.js';
 
 
 

 
 export const ObiBlowerOffVertical = createComponent({
   react: React,
   tagName: 'obi-blower-off-vertical',
   elementClass: ObiBlowerOffVerticalElement,
   events: {
     
   }
  });
 
 